module.exports = __webpack_public_path__ + "img/3.1b9e5cbb.jpg";